'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@repo/ui/components';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@repo/ui/components';
import { cn } from '@repo/ui/lib';
import { CheckCircleIcon, ChevronDownIcon, CircleIcon, ClockIcon, WrenchIcon, XCircleIcon } from 'lucide-react';
export const AITool = t0 => {
  const $ = _c(9);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      status: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  t1 === undefined ? "pending" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("not-prose mb-4 w-full rounded-md border", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <Collapsible className={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const getStatusBadge = status => {
  const labels = {
    completed: 'Completed',
    error: 'Error',
    pending: 'Pending',
    running: 'Running'
  };
  const icons = {
    completed: <CheckCircleIcon className="size-4 text-green-600" />,
    error: <XCircleIcon className="size-4 text-red-600" />,
    pending: <CircleIcon className="size-4" />,
    running: <ClockIcon className="size-4 animate-pulse" />
  };
  return <Badge className="rounded-full text-xs" variant="secondary">
      {icons[status]}
      {labels[status]}
    </Badge>;
};
export const AIToolHeader = t0 => {
  const $ = _c(20);
  let className;
  let name;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      className: t2,
      description,
      name: t3,
      status: t4,
      ...t5
    } = t0;
    className = t2;
    name = t3;
    t1 = t4;
    props = t5;
    $[0] = t0;
    $[1] = className;
    $[2] = name;
    $[3] = props;
    $[4] = t1;
  } else {
    className = $[1];
    name = $[2];
    props = $[3];
    t1 = $[4];
  }
  const status = t1 === undefined ? "pending" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("flex w-full items-center justify-between gap-4 p-3", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <WrenchIcon className="text-muted-foreground size-4" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== name) {
    t4 = <span className="text-sm font-medium">{name}</span>;
    $[8] = name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== status) {
    t5 = getStatusBadge(status);
    $[10] = status;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex items-center gap-2">{t3}{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ChevronDownIcon className="text-muted-foreground size-4 transition-transform group-data-[state=open]:rotate-180" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== props || $[17] !== t2 || $[18] !== t6) {
    t8 = <CollapsibleTrigger className={t2} {...props}>{t6}{t7}</CollapsibleTrigger>;
    $[16] = props;
    $[17] = t2;
    $[18] = t6;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export const AIToolContent = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("grid gap-4 overflow-hidden border-t p-4 text-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CollapsibleContent className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const AIToolParameters = t0 => {
  const $ = _c(15);
  let className;
  let parameters;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      parameters,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = parameters;
    $[3] = props;
  } else {
    className = $[1];
    parameters = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("space-y-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h4 className="text-muted-foreground text-xs font-medium tracking-wide uppercase">Parameters</h4>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== parameters) {
    t3 = JSON.stringify(parameters, null, 2);
    $[7] = parameters;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="bg-muted/50 rounded-md p-3"><pre className="text-muted-foreground overflow-x-auto text-xs">{t3}</pre></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t4) {
    t5 = <div className={t1} {...props}>{t2}{t4}</div>;
    $[11] = props;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export const AIToolResult = t0 => {
  const $ = _c(22);
  let className;
  let error;
  let props;
  let result;
  if ($[0] !== t0) {
    ({
      className,
      error,
      result,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = props;
    $[4] = result;
  } else {
    className = $[1];
    error = $[2];
    props = $[3];
    result = $[4];
  }
  if (!(result || error)) {
    return null;
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("space-y-2", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = error ? "Error" : "Result";
  let t3;
  if ($[7] !== t2) {
    t3 = <h4 className="text-muted-foreground text-xs font-medium tracking-wide uppercase">{t2}</h4>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = error ? "bg-destructive/10 text-destructive" : "bg-muted/50 text-foreground";
  let t5;
  if ($[9] !== t4) {
    t5 = cn("overflow-x-auto rounded-md p-3 text-xs", t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== error || $[12] !== result) {
    t6 = error ? <div>{error}</div> : <div>{result}</div>;
    $[11] = error;
    $[12] = result;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== props || $[18] !== t1 || $[19] !== t3 || $[20] !== t7) {
    t8 = <div className={t1} {...props}>{t3}{t7}</div>;
    $[17] = props;
    $[18] = t1;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};